import { Component, OnInit, ViewChild } from '@angular/core';
import { WfTableComponent } from '../../../common/table-sort/wf-table.component';
import { GenericModalService } from '../../../services/generic-modal.service';
import { UserMetadataAdminModalComponent } from './user-metadata-admin-modal/user-metadata-admin-modal.component';
import { BusinessProcessService } from '../../../services/business-process.service';
import {MetadataService} from '../../../services/configuration/metadata.service';
import {EnumTranslateService} from '../../../services/enumTranslate-service';
import {AdminService} from '../../../services/admin.service';

@Component({
  selector: 'app-user-metadata-admin',
  templateUrl: './user-metadata-admin.component.html',
  styleUrls: ['./user-metadata-admin.component.css']
})
export class UserMetadataAdminComponent implements OnInit {

  filteredMetadataList = [];
  metadataList: any[];
  pleaseWait = false;
  errorMessage: string;
  modalComponent: any = UserMetadataAdminModalComponent;
  hasRight: boolean;
  userList=[];
  selectedUser;
  filterSettings = {
    placeholder: 'Filtrar',
    width: 100,
    inputTextSearchId: 'txtSearchMetadata',
    showBooleanFilter: false,
    textFilterPropertyNames: ['structureName', 'value', 'typeDescription'],
    booleanTrueResult: true
  };
  @ViewChild(WfTableComponent, { static: false }) wfDataTable: WfTableComponent;

  constructor(
    private adminService: AdminService,
    private metadataService: MetadataService,
    private modalService: GenericModalService,
    private businessProcessService: BusinessProcessService
  ) { }

  ngOnInit() {
    this.loadUsers();
    this.checkRights();
  }

  loadUsers(){
    this.errorMessage = '';
    this.pleaseWait = true;
    this.adminService.loadUserList()
      .subscribe( list => {
        list.forEach(c => {
          this.userList = list;
        });

        this.pleaseWait = false;
      }, error => { this.errorMessage = error; this.pleaseWait = false; });
  }

  getUserMetadata(userId) {
    this.errorMessage = '';
    this.pleaseWait = true;
    this.metadataService.getAllMetadataEditingByAdmin(userId)
      .subscribe( list => {

        list.forEach(c => {
          c.typeDescription = EnumTranslateService.getEnumMetadataType(c.structure.type);
          c.structureName = c.structure.name
        });
        this.filteredMetadataList = list;
        this.metadataList = list;
        this.pleaseWait = false;
      }, error => { this.errorMessage = error; this.pleaseWait = false; });
  }

  changeUser(user) {
    if (!user){
      this.filteredMetadataList = null;
      this.metadataList = null;
      return;
    }
    this.getUserMetadata(user.userId);
  }

  onFilterList(filteredData: any[]) {
    this.filteredMetadataList = filteredData;
  }

  onEdit(metadata: any) {
    if (this.hasRight) {
      const result$ = this.modalService.showObjModal(this.modalComponent,
        'Editar valor de metadado', {metadata: metadata, userId: this.selectedUser});
      result$.asObservable()
        .subscribe(
          itemHasBeenSaved => {
            if (itemHasBeenSaved) { this.getUserMetadata(this.selectedUser); }
          }
        );
    } else {
      this.modalService.showErrorMessage('Usuário não tem direito a efetuar essa ação.', true);
    }
  }



  checkRights() {
    this.errorMessage = '';
    this.businessProcessService.checkRights(33554432)
      .subscribe( rights => {
        this.hasRight = rights.length > 0;
      }, error1 => {
        this.errorMessage = error1;
      });
  }
}
